import { render, staticRenderFns } from "./OrderContracts.vue?vue&type=template&id=6950fa99&scoped=true&"
import script from "./OrderContracts.vue?vue&type=script&lang=ts&"
export * from "./OrderContracts.vue?vue&type=script&lang=ts&"
import style0 from "./OrderContracts.vue?vue&type=style&index=0&id=6950fa99&lang=scss&scoped=true&"
import style1 from "./OrderContracts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6950fa99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCard,VCardText,VCardTitle,VDialog,VIcon,VOverlay,VProgressCircular,VTooltip})
